<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dscLocali') }}:
            |
            | {{ restricao.dsc_locali || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nmMun') }}:
            |
            | {{ restricao.nm_mun || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.siglaUf') }}:
            |
            | {{ formatNumber(restricao.sigla_uf) }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.certificac') }}:
            |
            | {{ formatNumber(restricao.certificac) }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.comunidade') }}:
            |
            | {{ formatNumber(restricao.comunidade) }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.comuniTer') }}:
            |
            | {{ formatNumberPercent(restricao.comuni_ter) }}
            Criticidade(v-if='restricao.nivelAlerta', :restricao='restricao')
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'incra-quilombolas',

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    }
};
</script>
